'use client';

import React from 'react';
import PropTypes from 'prop-types';

import ButtonImageText from '../ButtonImageText/ButtonImageText';
import Image from '../Image';
import { t } from '../../i18n';
import s from './Toolbar.module.scss';

export const ConnectedAccounts = ({ dashboards = [] }) => {
    if (!dashboards.length) {
        return null;
    }

    return (
        <div className={s.Accounts}>
            <span className={s.AccountsLabel}>
                {t('toolbar.connectedAccounts')}
            </span>
            {dashboards.map((dashboard) => (
                <ButtonImageText
                    key={dashboard.id}
                    title={dashboard.title}
                    url={dashboard.url}
                    modifiers={[
                        'ToolbarAccount',
                        ...(dashboard.isActive ? ['Current'] : []),
                    ]}
                    iconName={dashboard.isActive ? 'CheckSmallWhite' : 'Arrow'}
                    aria-current={dashboard.isActive ? 'page' : undefined}
                    attrTitle={t(
                        dashboard.isActive
                            ? 'toolbar.currentDashboard'
                            : 'toolbar.goToDashboard',
                        { title: dashboard.title }
                    )}>
                    {!!dashboard.listImage?.src && (
                        <span className={s.AccountLogo}>
                            <Image
                                {...dashboard.listImage}
                                alt=""
                                sizes={['28px']}
                                useCaption={false}
                                useCover={false}
                            />
                        </span>
                    )}
                </ButtonImageText>
            ))}
        </div>
    );
};

ConnectedAccounts.propTypes = {
    dashboards: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            url: PropTypes.string,
            title: PropTypes.string,
            isActive: PropTypes.bool,
            listImage: PropTypes.object,
        })
    ),
};

export default ConnectedAccounts;
